"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TransferenceEffectHandler = exports.TransferenceEffectArgs = void 0;
const _1 = require(".");
const __1 = require("../../..");
const Duration_1 = require("../../Duration");
const Registries_1 = require("../../state/Registries");
const EffectType_1 = require("../EffectType");
class TransferenceEffectArgs {
    constructor(baseDamagePerTurn, healingPercent) {
        this.baseDamagePerTurn = baseDamagePerTurn;
        this.healingPercent = healingPercent;
        this.__type = EffectType_1.EffectType.Transference;
        this.__typeName = "Transference";
        this.name = "Transference";
        this.harmful = true;
    }
}
exports.TransferenceEffectArgs = TransferenceEffectArgs;
let TransferenceEffectHandler = class TransferenceEffectHandler {
    apply(sequence, container, state) {
        state.meta.curseEffectId = container.applyDebuff({
            sequence,
            attackerId: state.creatorId,
            targetId: state.targetId,
            effect: new _1.CurseSiphonEffectArgs("Focus", state.args.baseDamagePerTurn, state.args.healingPercent),
            duration: Duration_1.Duration.Permanent,
            onApplied: (sequence) => {
                sequence.push(new __1.InstantVfxStepArgs(new __1.ActorVfxLocationSelector(state.targetId, "feet"), "EngulfingDarkness"));
            }
        });
    }
    remove(sequence, container, state) {
        container.cancelEffect(sequence, state.meta.curseEffectId);
    }
};
TransferenceEffectHandler = __decorate([
    Registries_1.Effects.register(EffectType_1.EffectType.Transference)
], TransferenceEffectHandler);
exports.TransferenceEffectHandler = TransferenceEffectHandler;
